<template>
  <div class="echarts" id="outNightEchart"></div>
</template>
<script >
import { defineComponent, reactive, toRefs, onMounted } from "vue";
import * as echarts from "echarts";
import {
  crouchChart,
  facecrouchChart,
} from "@/api/publicSecurityResearch/keyCarPerson.js";
export default defineComponent({
  name: "countEchart",
  components: {},
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const state = reactive({
      chartX: [],
      chartDayY: [],
      chartNightY: [],
    });
    const refData = toRefs(state);
    let myChart;
    const echartsTopLeft = async () => {
      myChart = echarts.init(document.getElementById("outNightEchart"));
      const option = {
        grid: {
          left: "15%",
          right: "10%",
          top: "20%",
          bottom: "5%",
          containLabel: true,
        },
        // legend: {
        //   left: "10%",
        //   top: "center",
        //   orient: "vertical",
        //   itemGap: 20,
        //   width: 300
        // },
        tooltip: {
          show: true,
          trigger: "item",
          // formatter: '{b} {a}{c}次'
          formatter: function (v) {
            const html = `
                    <div>
                      <div>
                        <span>时间:</span>  
                        <span> ${v.name}时&nbsp;</span>  
                     </div>
                      <div>
                        <span>类型:</span>  
                        <span> ${v.seriesName}&nbsp;</span> 
                       </div>
                      <div>
                        <span>次数 :</span>  
                        <span> ${v.value}&nbsp;</span>
                      </div>                      
                    </div>`;
            return html; // value.name+value.seriesName+value.value
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: {
            color: "#30eee9",
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#397cbc",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          // data: []
          data: state.chartX,
        },
        yAxis: [
          {
            type: "value",
            name: "出没次数",
            min: 0,
            // max: 8,
            axisLabel: {
              // formatter: "{value}",
              textStyle: {
                color: "#2ad1d2",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#27b4c2",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "夜出",
            type: "line",
            stack: "总数",
            symbol: "circle",
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: "#00d4c7",
                lineStyle: {
                  color: "#00d4c7",
                  width: 1,
                },
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: "rgba(7,44,90,0.3)",
                    },
                    {
                      offset: 1,
                      color: "rgba(0,212,199,0.9)",
                    },
                  ]),
                },
              },
            },
            data: state.chartNightY,
          },
          {
            name: "昼出",
            type: "line",
            stack: "总数",
            symbol: "circle",
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: "#00d4c7",
                lineStyle: {
                  color: "#00d4c7",
                  width: 1,
                },
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: "rgba(7,44,90,0.3)",
                    },
                    {
                      offset: 1,
                      color: "rgba(0,212,199,0.9)",
                    },
                  ]),
                },
              },
            },
            data: state.chartDayY,
          },
        ],
      };
      myChart.setOption(option);
    };
    const getcrouchChart = async () => {
      state.chartX = [];
      state.chartDayY = [];
      state.chartNightY = [];
      let res;
      if (props.type == "face") {
        console.log("renfsdfds");
        res = await facecrouchChart(props.params);
      } else {
        res = await crouchChart(props.params);
      }

      if (res.code == 0) {
        res.data.dayPoints.forEach((element) => {
          state.chartX.push(parseInt(element.hour));
          state.chartDayY.push(parseInt(element.count));
        });
        res.data.nightPoints.forEach((element) => {
          state.chartNightY.push(parseInt(element.count));
        });
        echartsTopLeft();
      }
    };

    onMounted(() => {
      getcrouchChart();
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    });

    return { ...refData };
  },
});
</script>
<style  lang='scss' scoped >
#outNightEchart {
  width: 100%;
  height: 100%;
}
</style>